import { type App } from 'vue'
import { AppError, notificationSink } from '@gat-ship/error-handling'

/**
 * Last-resort catch for Vue component/lifecycle errors. AppError instances are
 * routed through the notification sink so the user sees them; anything else
 * (template crashes, missing refs, etc.) is logged for developers but not
 * surfaced to the UI because it's not actionable from the user's side.
 */
export function handleGlobalErrors(app: App) {
  app.config.errorHandler = (err, _vm, info) => {
    console.error('[global error handler]', info, err)
    if (err instanceof AppError) {
      notificationSink.reportError(err)
    }
  }
}
